import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';

function Header() {
    const location = useLocation();
    const navigate = useNavigate();
    const isAdmin = location.pathname.startsWith('/admin');
    const [userEmail, setUserEmail] = useState(null);

    useEffect(() => {
        const email = localStorage.getItem('userEmail');
        setUserEmail(email);
    }, [location]);

    const handleLogout = () => {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userEmail');
        setUserEmail(null);
        navigate('/');
    };

    return (
        <header className="header">
            <div className="header-top">
                <div className="header-top-content">
                    <Link to="/" className="logo">
                        <img src="/kaios-logo.svg" alt="KaiOS" className="logo-img" />
                    </Link>
                    {!isAdmin && (
                        <nav className="nav">
                            <Link 
                                to="/" 
                                className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                            >
                                Submit Bug
                            </Link>
                            <Link 
                                to="/track" 
                                className={`nav-link ${location.pathname === '/track' ? 'active' : ''}`}
                            >
                                Track Bugs
                            </Link>
                            {userEmail ? (
                                <div className="user-menu">
                                    <span className="user-email">{userEmail}</span>
                                    <button className="logout-btn" onClick={handleLogout}>
                                        Logout
                                    </button>
                                </div>
                            ) : (
                                <Link 
                                    to="/login" 
                                    className={`nav-link ${location.pathname === '/login' ? 'active' : ''}`}
                                >
                                    Login
                                </Link>
                            )}
                        </nav>
                    )}
                </div>
            </div>
            <div className="header-sub">
                <div className="header-sub-content">
                    <span className="header-sub-title">Security Bug Feedback Portal</span>
                </div>
            </div>
        </header>
    );
}

export default Header;
